export default function TrustSection() {
  const points = [
    { icon: 'ri-information-line', text: 'We provide independent informational resources about Sugargoo shopping.' },
    { icon: 'ri-store-2-line', text: 'We do not directly sell products. Our goal is to educate and inform shoppers.' },
    { icon: 'ri-guide-line', text: 'We help users understand products, costs, shipping methods and shopping processes.' },
    { icon: 'ri-refresh-line', text: 'Our Sugargoo Spreadsheet data is updated regularly to reflect the latest product information.' },
    { icon: 'ri-user-heart-line', text: 'Built by shoppers, for shoppers. We understand what the community needs.' },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
          Why Trust Us
        </span>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          Independent &amp; Reliable Sugargoo Spreadsheet Resources
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8">
          Our mission is to provide transparent, accurate, and regularly updated information about Sugargoo shopping. We are an independent resource dedicated to helping shoppers make better decisions.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left">
          {points.map((point, index) => (
            <div key={index} className="flex items-start gap-3 p-4 rounded-lg bg-background-50">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0 mt-0.5">
                <i className={`${point.icon} text-sm`}></i>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{point.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}